import React from 'react';
import styled from 'styled-components';
import MdInfoOutline from '../icons/info-circle-solid.svg';
import { Icon, IconProps } from '../icon';
import { forwardRef } from 'react';

const _HelpIcon = styled(Icon)`
    color: ${(props) => props.theme.app.component.icon.help.color};
    width: ${(props) => props.theme.app.component.icon.help.width};
    height: ${(props) => props.theme.app.component.icon.help.height};
`;

export const HelpIcon = forwardRef<HTMLDivElement, IconProps & { $hoverable?: boolean }>((props, ref) => {
    return (
        <_HelpIcon {...props} ref={ref}>
            <MdInfoOutline />
        </_HelpIcon>
    );
});

export const HelpIconContainer = styled(Icon)`
    width: ${(props) => props.theme.app.component.icon.help.width};
    height: ${(props) => props.theme.app.component.icon.help.height};
`;
